import Vue from "vue";
import Vuetify from "vuetify";
Vue.use(Vuetify);

const opts = {
  theme: {
    disable: true // This stops Vuetify from generating theme classes
  }
};

export default new Vuetify(opts);
